import { render, staticRenderFns } from "./newsVideoCenter.vue?vue&type=template&id=939b3cc0&scoped=true&"
import script from "./newsVideoCenter.vue?vue&type=script&lang=js&"
export * from "./newsVideoCenter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./newsVideoCenter.vue?vue&type=style&index=0&id=939b3cc0&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "939b3cc0",
  "2f126ed4"
  
)

export default component.exports